import { useMutation } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../../../services/queryClient";

export const useVerifyOTPMutation = (otp: string) => {
  const token = localStorage.getItem("W2ST_STUDENT_TOKEN");

  return useMutation(
    () =>
      axiosInstance
        .post(
          "auth/verify-otp",
          { otp: otp },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res: any) => res.data),
    {
      onSuccess: async (data) => {
        queryClient.invalidateQueries("getuser");
        message.success(data?.data);
      },
      onError: (error: any) => {
        message.error(error?.response?.data?.message);
      },
    }
  );
};
